import 'core-js/stable'
import 'regenerator-runtime/runtime';
import VueDOMPurifyHTML from 'vue-dompurify-html'
require('moment/locale/fr');
import { createApp } from 'vue'
import App from './App'
import router from './router'
import { createI18n } from 'vue-i18n/index'
import CoreuiVue from '@mz/coreui-vue'
import CTooltip from "@mz/coreui-vue/src/directives/CTooltip";
import {iconsSet as icons} from './assets/icons/icons.js'
import store from './store'
import MzRd from 'mz-rd';
import Scrollspy from 'vue2-scrollspy';
import hljs from 'highlight.js/lib/core';
import hljsYaml from 'highlight.js/lib/languages/yaml';
import 'highlight.js/styles/default.css';
import { BASE_URL } from '@/constants/config';
import { locales } from '@/locales';

const app = createApp(App)

app.use(CoreuiVue);
app.directive('tooltip', CTooltip);
app.use(MzRd, {
  apiUrl: BASE_URL,
  tableClassess: 'mz-table',
  isRaTable: true,
  tokenBearer: 'Bearer',
});

export const i18n = createI18n({
  locale: navigator.language.split("-")[0],
  fallbackLocale: "en",
  messages: locales,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});

app.use(Scrollspy);
app.use(VueDOMPurifyHTML);
hljs.registerLanguage('yaml', hljsYaml);
app.use(hljs.vuePlugin);

app.config.performance = true;

app.use(icons);
app.use(store);
app.use(router);
app.use(i18n);
app.mount("#app");
